import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import Skeleton from '@mlb/react-patterns/components/Skeleton/skeleton.tsx';

import { useImageUtils } from '../../hooks';
import Card from '../AspectRatioCard';
import ScalableTextBox from '../ScalableText';

const BASE_WIDTH = 167;
const BASE_HEIGHT = 180;
const ASPECT_RATIO = `${BASE_WIDTH}:${BASE_HEIGHT}`;

const Image = styled.img`
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
`;

const ScalableText = styled(ScalableTextBox)`
    position: absolute;
    margin: auto;
    top: 0;
    bottom: 0;
`;

const CategoryTitle = styled.span`
    display: flex;
    align-items: center;
    text-align: center;
    justify-content: center;
    font-weight: 800;
    width: 100%;
    height: 100%;
    padding: 0 8px;
    box-sizing: border-box;
    text-transform: uppercase;
    line-height: 1.1;
`;

const CategoryCard = (props) => {

    const {
        category,
        imageTemplateUrl: templateUrl,
        imgSizes,
        imageWidths,
        loading,
        ...otherProps
    } = props;

    const { formatImageUrl } = useImageUtils();

    const imageSrc = formatImageUrl({
        templateUrl,
        width: imageWidths[imageWidths.length - 1],
        aspectRatio: ASPECT_RATIO,
    });
    const imageSrcSet = imageWidths.map((width) => `${formatImageUrl({
        templateUrl,
        width,
        aspectRatio: ASPECT_RATIO,
    })} ${width}w`).join(', ');

    return (
        <Card
            aspectRatio={ASPECT_RATIO}
            {...otherProps}
        >
            { loading ? (
                <Skeleton margin={0} />
            ) : (
                <>
                    <Image
                        alt={category}
                        src={imageSrc}
                        srcSet={imageSrcSet}
                        sizes={imgSizes}
                        loading="lazy"
                    />
                    <ScalableText
                        viewBoxWidth={BASE_WIDTH}
                        viewBoxHeight={BASE_HEIGHT}
                        fontSize={'20px'}
                    >
                        <CategoryTitle>{category}</CategoryTitle>
                    </ScalableText>
                </>
            )}
        </Card>
    );

};

CategoryCard.propTypes = {
    category: PropTypes.string,
    imageTemplateUrl: PropTypes.string,
    imgSizes: PropTypes.string,
    imageWidths: PropTypes.array,
    loading: PropTypes.bool,
};

CategoryCard.defaultProps = {
    loading: false,
    imageWidths: [
        120,
        168,
        372,
        640,
    ],
};

export default CategoryCard;
